import React from 'react';
import { Typography, Button, Box } from '@mui/material';

const POPUP_TITLE_MAX = 45;
const POPUP_DESC_MAX = 100;

function truncate(str, max) {
  if (!str || typeof str !== 'string') return '';
  const s = str.trim();
  if (s.length <= max) return s;
  return s.slice(0, max).trim() + '\u2026';
}

export default function SimplePopup({ place, onViewMore }) {
  if (!place) return null;

  const title = truncate(place.title, POPUP_TITLE_MAX);
  const shortDesc = truncate(place.description, POPUP_DESC_MAX) || 'Sin descripción.';

  return (
    <Box
      sx={{
        p: 1.5,
        minWidth: 200,
        maxWidth: 280,
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 700,
          fontSize: '15px',
          mb: 0.75,
          wordBreak: 'break-word',
          lineHeight: 1.3,
          color: 'primary.main',
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          lineHeight: 1.45,
          color: 'text.secondary',
          fontSize: '13px',
          wordBreak: 'break-word',
          mb: onViewMore ? 1.25 : 0,
        }}
      >
        {shortDesc}
      </Typography>
      {onViewMore && (
        <Button
          variant="contained"
          size="small"
          onClick={() => onViewMore(place)}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          Ver más
        </Button>
      )}
    </Box>
  );
}
